/**
 * Maps color name to image color name for product images
 */
export function mapColorToImageColor(color: string): string {
  const colorMap: Record<string, string> = {
    Beige: 'Beige',
    White: 'White',
    'Light Grey': 'Light Grey',
    Grey: 'Grey',
    'Beige Almond': 'Beige Almond',
  }
  return colorMap[color] || 'Beige Almond'
}
